export const TITLE = "activation.setup.name.step.title";
export const CHIP_TITLE = "activation.setup.name.step.chip.title";
export const INPUT_TITLE = "activation.setup.name.step.input.title";
export const BODY_TEXT = "activation.setup.name.step.body.text";
export const TOOLTIP = "activation.setup.name.step.body.tooltip";
export const SUBSCRIPTION_TEXT = "activation.setup.name.step.subscription.text";
export const ERROR_MESSAGES = {
    MAX_CHARACTERS_REACHED: "activation.setup.name.error.max.characters",
    ALREADY_USED: "activation.setup.name.error.name.used",
    TOO_SMALL: `activation.setup.name.error.min.characters`,
};
